define([
	"dojo/_base/declare",
	"csi/xml",
	"./Actual"
], function(declare, xml, Actual) {

	return declare(Actual, {
		getDefaultValue: function(/*Heading*/h) {
			// summary: return default value for heading
			return this.DEFAULT;
		},

		pushContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: matrix will already establish node context, so we can ignore path and continue
			ctx.pushParams();
			return true;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: calculate keys into DimensionActuals doublemap
			var scd = ctx.getRowNode();
			ctx.keyValue = this._getDimensionActualsKey(ctx, scd);
			ctx.keyValue2 = this._getDimensionActualsKeyPre47(ctx, scd);
			ctx.keyOriginalValue = this._getDimensionOriginalKey(ctx, scd);
			ctx.keySuffix = this._getDimensionActualsKeySuffix(ctx, scd);   // To support unlinked/special SizeChartDimension
			this.inherited(arguments);
		}
	});
});